console.log("init Proteus treatments -- 1.01")

if(window.location.href.indexOf("/products/4lb-collagen-peptides-bag") > -1){}
// 4lb PDP -- hide MONTHS options
/* 
1mo: 1241153671
2mo: 1241186439
3mo: 1241219207
4wk: 3022454919
6wk: 3022487687
8wk: 3022520455
12wk: 3022553223
24wk: 3022585991
*/
waitForElement('skio-plan-picker').then(plan_picker => {

    waitUntil(() => {

        return !!(
            plan_picker.shadowRoot &&
            plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown') &&
            plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options.length > 0
        );

    }).then(() => {

        let selling_plans_options = plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options;
        for(let i = 0; i < selling_plans_options.length; i++){
            if(selling_plans_options[i].value == "3022454919" || 
            selling_plans_options[i].value == "3022487687" || 
            selling_plans_options[i].value == "3022520455" || 
            selling_plans_options[i].value == "3022553223" || 
            selling_plans_options[i].value == "3022585991"){
                selling_plans_options[i].hidden = true;
            } 
        }

    }).catch();

}).catch();
